/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Regenerate_MenuInputs */



/**
* | output |
* | --- |
* | "More ways to regenerate" |
*
* @param {Chat_Regenerate_MenuInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_regenerate_menu = /** @type {((inputs?: Chat_Regenerate_MenuInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Regenerate_MenuInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Weitere Möglichkeiten zum Neugenerieren")
	return /** @type {LocalizedString} */ ("More ways to regenerate")
});